import React, { useEffect } from 'react';
import { Box, FormControl, IconButton, TextField } from '@mui/material';
import moment from 'moment-timezone';
import LocalizedDatePicker from '../../../../custom-widgets/LocalizedDatePicker';
import { CustomPickersDay } from '../../../../custom-components';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { NavigateBeforeOutlined, NavigateNextOutlined } from '@mui/icons-material';

export default function WeekSelector({ name, props }) {
    const { control, getValues, updateSelectedValues, watch } = useFormContext();

    useEffect(() => {
        const existingValue = getValues(name);
        if (updateSelectedValues) {
            updateSelectedValues(name, existingValue);
        }
    }, [watch(name)]);

    return (
        <FormControl>
            <Controller
                control={control}
                name={name}
                defaultValue={moment().startOf('week')}
                render={({ field: { onChange, value } }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginBottom: '1rem' }}>
                        <IconButton onClick={() => onChange(value.clone().subtract(1, 'week'))}>
                            <NavigateBeforeOutlined />
                        </IconButton>
                        <LocalizedDatePicker
                            Picker={DatePicker}
                            value={value.startOf('week')}
                            onChange={onChange}
                            showDaysOutsideCurrentMonth
                            slots={{ field: TextField, day: CustomPickersDay }}
                            slotProps={{
                                field: {
                                    value: `${value.format('MMMM D')} - ${value.clone().endOf('week').format('D, YYYY')}`,
                                    InputProps: { disableUnderline: true },
                                },
                                day: {
                                    range: {
                                        startDate: value.startOf('week'),
                                        endDate: value.clone().endOf('week'),
                                    },
                                },
                            }}
                            {...props}
                        />
                        <IconButton onClick={() => onChange(value.clone().add(1, 'week'))}>
                            <NavigateNextOutlined />
                        </IconButton>
                    </Box>
                )}
            />
        </FormControl>
    );
}
